import { render, staticRenderFns } from "./Instance.vue?vue&type=template&id=2742bd56&scoped=true&"
import script from "./Instance.vue?vue&type=script&lang=js&"
export * from "./Instance.vue?vue&type=script&lang=js&"
import style0 from "./Instance.vue?vue&type=style&index=0&id=2742bd56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742bd56",
  null
  
)

export default component.exports